import React, {
    // useRef,
    useState,
    // useLayoutEffect,
    // useEffect,
    // useCallback
} from "react";
// import {declareVariable} from "@babel/types";
import clsx from 'clsx';
import './sideNavigationBar.scss';
import ArrowImg from './arrow.png';
import {treeData as data} from '../config';

interface ISideNavigationBarProps {
    name?: string,
    handleClick: (node: INode) => void
}


interface INode {
    label: string,
    id: string,
    inHouse?: boolean,
    anchor?: boolean,
    children?: Array<INode> | undefined | null
}

interface IStatus {
    [key: string]: boolean | undefined;
}

const SideNavigationBar: React.FC<ISideNavigationBarProps> = (props) => {
    const [status, setStatus] = useState({"terms-and-conditions": true, general:true} as IStatus);

    const renderNode = (node: INode, isRoot: boolean, ancestorIDs: any): any => {
        let children;
        const isLeaf: boolean = !(node.children && node.children.length);
        const selected: boolean | undefined = status[node.id];
        const selectedNotRoot = !isRoot && selected;
        const ancestors = [node.id, ...ancestorIDs];

        if (node.children && node.children.length) {
            children = node.children.map((node: INode) => {
                return renderNode(node, false, ancestors);
            })
        }

        const handleClick = (node: INode): any => (e: React.MouseEvent) => {
            e.stopPropagation();
            console.log(node.id,ancestors, status[node.id], status);

            props.handleClick(node);

            const currentStatus = {};
            ancestors.forEach((item)=>{
               currentStatus[item] = true;
            });
            currentStatus[node.id] = isLeaf ? true : !status[node.id];
            setStatus(currentStatus);
        };

        // const handleAnchorClick = (e) => {
        //     e.stopPropagation();
        //     console.log("test", e);
        //     window.scroll(0, -1000);
        // };

        const nodeDom = <div className={clsx({
            "node": true,
            "node-selected": selected,
            "node-left-bar": selectedNotRoot,
        })}>
            <span>{node.label}</span>
            <img src={ArrowImg} alt=""
                 className={clsx({"hidden": isLeaf, "transform rotate-180": selected})}/>
        </div>;

        return <div key={node.id} onClick={handleClick(node)}>
            {nodeDom}
            {/*{node.anchor?<a href={`#${node.id}`} onClick={handleAnchorClick}>{nodeDom}</a>:nodeDom}*/}
            {!isLeaf && <div className={clsx({
                "node-children-container": true,
                "node-children-container-close": !selected,
            })}>
                {children}
            </div>}
        </div>
    };
    const renderTree = (nodes: Array<INode>): any => {
        if (nodes.length) {
            return nodes.map((node: INode) => {
                return renderNode(node, true, []);
            })
        }
        return <div>
            No navigation data yet
        </div>
    };
    return (
        <div className="side-bar">
            {renderTree(data)}
        </div>
    );
};

export default SideNavigationBar;
